import  { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import { validationSchema } from "../../utils/validations/fireArea";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, Form } from "formik";
import axios from "../../libs/axios";
import ImageUpload from "../../components/common/imageUpload/ImageUpload";

export default function UploadCustom({
  formData,
  handlePreviousPage,
  previouscallingBackend,
  setPreviousCallingBackend,
  handleNextPage,
  callingBackend,
  setCallingBackend,
}) {
  const { state } = useLocation();
  const [assessmentType, setAssessmentType] = useState("full");
  const [customTitle, setCustomTitle] = useState(false);
  const [titleText, setTitleText] = useState("");
  const [frontImage, setFrontImage] = useState(
      "https://firebasestorage.googleapis.com/v0/b/prs-images.firebasestorage.app/o/files%2FFront%20Page.jpgFri%20Apr%2010%202026%2011%3A27%3A52%20GMT%2B0530%20(India%20Standard%20Time)?alt=media&token=61c6953d-3917-40f7-93e1-a52b40188ba8"
    );
  const [backImage, setBackImage] = useState(
    "https://firebasestorage.googleapis.com/v0/b/prs-images.firebasestorage.app/o/files%2Fbackpages.jpgFri%20Apr%2010%202026%2011%3A28%3A05%20GMT%2B0530%20(India%20Standard%20Time)?alt=media&token=9887e0ad-1746-4399-8030-62565edb2e2d"
  );

  // eslint-disable-next-line
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });

  const handleClick = () => {
    setPreviousCallingBackend(true);
    handlePreviousPage();
  };

  const submit = async () => {
    try {
      setCallingBackend(true);
      await axios.put(`/assesment/custom-page/${state.id}`, {
        frontImage: frontImage,
        backImage: backImage,
        assessmentType: assessmentType,
        customTitle: customTitle,
        titleText: titleText,
      });

      setAlert({
        showAlert: true,
        severity: "success",
        message: "Custom details created successfully!",
      });
      setTimeout(
        () =>
          setAlert({
            showAlert: false,
            severity: "success",
            message: "Custom details created successfully!",
          }),
        handleNextPage(),
        5000
      );
    } catch (error) {
      if (error.response.data === "Custom details already exists") {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Custom details already exists!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Custom details already exists!",
            }),
          5000
        );
      } else if (error.response.status === 401) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Unauthorized Access!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Unauthorized Access!",
            }),
          5000
        );
      } else if (error.response.status === 500) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Server Error!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Server Error!",
            }),
          5000
        );
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Custom details already exists!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Custom details already exists!",
            }),
          5000
        );
      }
    }
  };

  useEffect(() => {
    // setFrontImage(formData?.frontImage);
    // setBackImage(formData?.backImage);
    setAssessmentType(formData?.assessmentType);
    setTitleText(formData?.titleText);
    setCustomTitle(formData?.customTitle);
  }, [formData]);

  return (
    <Formik
      //   initialValues={initialValues}
      onSubmit={submit}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ dirty, isValid, values, setFieldValue }) => {
        return (
          <Form>
            <Grid
              container
              xs={12}
              sx={{
                padding: "1rem",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container item xs={10} spacing={1}>
                <Grid
                  item
                  xs={12}
                  style={{
                    paddingBottom: "16px",
                    marginBottom: "24px",
                  }}
                >
                  <h1
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "#1f2937",
                    }}
                  >
                    Assessment Configuration
                  </h1>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: "32px",
                  }}
                >
                  <h2
                    style={{
                      fontSize: "18px",
                      fontWeight: 500,
                      color: "#374151",
                      marginBottom: "12px",
                    }}
                  >
                    Select Assessment Type
                  </h2>
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        name="assessmentType"
                        value="full"
                        checked={assessmentType === "full"}
                        onChange={() => setAssessmentType("full")}
                        style={{
                          width: "20px",
                          height: "20px",
                          color: "#2563eb",
                        }}
                      />
                      <span>Full Engineering Report</span>
                    </label>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        name="assessmentType"
                        value="basic"
                        checked={assessmentType === "basic"}
                        onChange={() => setAssessmentType("basic")}
                        style={{
                          width: "20px",
                          height: "20px",
                          color: "#2563eb",
                        }}
                      />
                      <span>Basic Engineering Report</span>
                    </label>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: "32px",
                  }}
                >
                  <Grid
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "16px",
                    }}
                  >
                    <span>Custom report Title</span>
                    <Grid
                      style={{
                        position: "relative",
                        width: "48px",
                        height: "24px",
                        borderRadius: "999px",
                        cursor: "pointer",
                        transition: "background-color 0.3s",
                        backgroundColor: customTitle ? "#2563eb" : "#d1d5db",
                      }}
                      onClick={() => setCustomTitle(!customTitle)}
                    >
                      <Grid
                        style={{
                          position: "absolute",
                          top: "4px",
                          width: "16px",
                          height: "16px",
                          backgroundColor: "white",
                          borderRadius: "50%",
                          transition: "transform 0.3s",
                          transform: customTitle
                            ? "translateX(28px)"
                            : "translateX(4px)",
                        }}
                      />
                    </Grid>
                  </Grid>
                  {customTitle && (
                    <Grid>
                      <label>Custom title input:</label>
                      <input
                        type="text"
                        value={titleText}
                        onChange={(e) => setTitleText(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 12px",
                          border: "1px solid #d1d5db",
                          borderRadius: "6px",
                          outline: "none",
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: "32px",
                  }}
                >
                  <h2
                    style={{
                      fontSize: "18px",
                      fontWeight: 500,
                      color: "#374151",
                      marginBottom: "12px",
                    }}
                  >
                    Upload Custom Images
                  </h2>

                  <Grid
                    container
                    xs={12}
                    spacing={1}
                    sx={{
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Grid
                      container
                      item
                      xs={5.5}
                      sx={{
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sx={{
                          borderColor: "#eeeeee",
                          borderStyle: "dashed",
                          padding: "1rem 0",
                          margin: "2rem 0",
                        }}
                      >
                        <div>
                          <label>Front Cover</label>
                          <ImageUpload
                            setImage={setFrontImage}
                            image={frontImage}
                            name="frontImage"
                          />
                        </div>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={5.5}
                      sx={{
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sx={{
                          borderColor: "#eeeeee",
                          borderStyle: "dashed",
                          padding: "1rem 0",
                          margin: "2rem 0",
                        }}
                      >
                        <div>
                          <label>Back Cover</label>
                          <ImageUpload
                            setImage={setBackImage}
                            image={backImage}
                            name="backImage"
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sx={{
                    alignContent: "center",
                    justifyContent: "space-between",
                    marginTop: "2rem",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() => handleClick()}
                    sx={{
                      backgroundColor: "#22345B",
                      textTransform: "capitalize",
                      fontFamily: "serif",
                      borderRadius: "8px",
                      ":hover": { backgroundColor: "#22345B" },
                    }}
                    disabled={previouscallingBackend}
                  >
                    {previouscallingBackend ? (
                      <CircularProgress
                        size={25}
                        sx={{ color: "#22345B", margin: "0 5px" }}
                      />
                    ) : (
                      "Previous"
                    )}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => submit()}
                    sx={{
                      backgroundColor: "#22345B",
                      textTransform: "capitalize",
                      fontFamily: "serif",
                      borderRadius: "8px",
                      ":hover": { backgroundColor: "#22345B" },
                    }}
                    disabled={callingBackend}
                  >
                    {callingBackend ? (
                      <CircularProgress
                        size={25}
                        sx={{ color: "#22345B", margin: "0 5px" }}
                      />
                    ) : (
                      "Next"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
}
